import { useEffect, useState } from "react";

// useDebounce — returns `value` delayed by `delay` ms. Used by search inputs on
// server-paginated tables so typing does not fire a request per keystroke.
export default function useDebounce(value, delay = 300) {
  const [debounced, setDebounced] = useState(value);

  useEffect(() => {
    const handle = setTimeout(() => setDebounced(value), delay);
    return () => clearTimeout(handle);
  }, [value, delay]);

  return debounced;
}
